var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormValidation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#EEF0F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 260,
    width: 531,
    height: 116,
    rx: 12,
    fill: "white",
    stroke: "#007BC1",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 65,
    width: 531,
    height: 116,
    rx: 12,
    fill: "#E0EEF8",
    stroke: "#007BC1",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 277,
    width: 154,
    height: 28,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 82,
    width: 100,
    height: 28,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 197,
    width: 154,
    height: 19,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 197,
    width: 88,
    height: 19,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 318,
    width: 313,
    height: 41,
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 123,
    width: 426,
    height: 41,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 289,
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.375 327.404L600.471 317.5L597.099 320.849L610.375 334.125L638.875 305.625L635.526 302.276L610.375 327.404Z",
    fill: "#007BC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 414,
    width: 236,
    height: 95,
    rx: 16,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: -12,
    width: 539,
    height: 28,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 429,
    width: 198,
    height: 40,
    fill: "#D5D8DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 433,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#E2E5E5",
    stroke: "#9CA5A9",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 458,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750,
    width: 64,
    height: 458,
    fill: "#B9BFC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormValidation);
export default __webpack_public_path__ + "static/media/form-validation.d1b45cc6fff98713f74190f21c1a0e0b.svg";
export { ForwardRef as ReactComponent };